export default __webpack_public_path__ + "static/media/curlicon.17fc0197.svg";